export default __webpack_public_path__ + "static/our-goals-512624b5585d25878b51481e6dfd5837.png";